import { signIn } from 'next-auth/react';

/** NextAuth Credentials provider ส่ง status 403 เมื่อบัญชียังไม่ยืนยัน (ตามที่ใช้ใน AuthLogin เดิม) */
export const UNVERIFIED_ACCOUNT_STATUS = 403;

export type CredentialsSignInResult =
  | { ok: true; url: string | null }
  | { ok: false; error: string; status?: number; isUnverified: boolean };

/**
 * เข้าสู่ระบบผ่าน provider `login` (Credentials) แบบไม่ redirect อัตโนมัติ — ให้หน้า UI จัดการ error / unverified
 */
export async function signInWithCredentials(email: string, password: string): Promise<CredentialsSignInResult> {
  const trimmedEmail = email.trim();

  const res = await signIn('login', {
    redirect: false,
    email: trimmedEmail,
    password
  });

  if (!res) {
    return { ok: false, error: 'ไม่ได้รับการตอบกลับจากระบบ กรุณาลองใหม่อีกครั้ง', isUnverified: false };
  }

  if (res.error) {
    return {
      ok: false,
      error: res.error,
      status: res.status,
      isUnverified: res.status === UNVERIFIED_ACCOUNT_STATUS
    };
  }

  if (res.ok) {
    return { ok: true, url: res.url ?? null };
  }

  return { ok: false, error: 'เข้าสู่ระบบไม่สำเร็จ', isUnverified: false };
}
